import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { commissionEditAction, commissionSearchAction } from '../commission-container/actions/CommissionActions';
import CommissionForm from '../commission-container/CommissionForm';
import TargetForm from './TargetForm';
import { targetEditAction, targetSearchAction } from './actions/TargetActions';
import { targetSearchAPI } from 'src/api/TargetApi';



const tabs = [
    {
        title: 'Manage',
        link: RoutingUtil.teamTargetManagerUrl(),
    },
    {
        title: 'Search',
        link: RoutingUtil.teamTargetSearch(),
    },
];

const routes = [
    {
        link: RoutingUtil.teamTargetManagerUrl(),
        component: () => (
            <PermissionHOC
                scope="master.target_manager.manage"
                fallback={<UnAuthorizedErrorPage />}
                component={<TargetForm />}
            />
        ),
    },
    {
        link: RoutingUtil.teamTargetSearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.target_manager.search"
                editScope="master.target_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="TargetReducer"
                dataPath="search"
                editAction={targetEditAction}
                redirectUrlOnEdit={RoutingUtil.teamTargetManagerUrl()}
                action={targetSearchAction}
                columns={{
                    commissionName: {
                        display: 'Commission Name',
                        path:"targetName"
                    },
                    FromDate: {
                        display: 'FromDate',
                        type: Date,
                    },
                    ToDate: {
                        display: 'ToDate',
                        type: Date,
                    },
                    companyId: {
                        display: 'Company Name',
                        path: 'companyId.companyName',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const TargetContainer = () => (
    <CrudLayoutContainer
        title="Team Target Manager"
        tabs={tabs}
        routes={routes}
    />
);

TargetContainer.propTypes = {
};

export default TargetContainer;
